import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import {
    injectConfigAPI,
    injectFetch,
    injectLog,
    injectQueryURL,
    TYPES as UTIL_TYPES,
} from '@monofe/util';
import { injectAuthAPI } from '../interface';
import type { IAuthAPI } from '../interface/auth';
import { bindAuthAPI, TYPES, unbindAuthAPI } from '../interface/bind';
import authImpl from './auth';

function _build(container: IContainer): Readonly<IAuthAPI> {
    const fetcher = injectFetch(container);
    const logger = injectLog(container);
    const configAPI = injectConfigAPI(container);
    const query = injectQueryURL(container);

    const auth: IAuthAPI = {
        authenticate: (apiUrl: string, username: string, password: string, timeout?: number) =>
            authImpl(
                fetcher,
                logger,
                query,
                [
                    {
                        /* Take the default parameters & apply our overrides */
                        ...configAPI.auth,
                        apiExtension: configAPI.extension.auth,
                        username,
                        password,
                        apiUrl,
                    },
                ],
                timeout,
            ),
    };

    return Object.freeze(auth);
}

export default buildBindable<IAuthAPI>({
    id: TYPES.IAuthAPI,
    dependencies: [UTIL_TYPES.IFetch, UTIL_TYPES.ILog, UTIL_TYPES.IQueryURL, UTIL_TYPES.IConfigAPI],
    bind: bindAuthAPI,
    remove: unbindAuthAPI,
    build: container => Promise.resolve(_build(container)),
    inject: injectAuthAPI,
});
